// extracted by mini-css-extract-plugin
export var notificationHost = "_k9-0";